export enum RulesEngineMessageType {
	Warning = 1,
	Contradiction = 2,
}
